 const api="https://api.bet555mix.com/api"; // production

//const api="http://167.172.4.158:8080/financepro/api"; // staging

export default api;